import { render, staticRenderFns } from "./DailyZbon.vue?vue&type=template&id=0352050b&scoped=true&"
import script from "./DailyZbon.vue?vue&type=script&lang=js&"
export * from "./DailyZbon.vue?vue&type=script&lang=js&"
import style0 from "./DailyZbon.vue?vue&type=style&index=0&id=0352050b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0352050b",
  null
  
)

export default component.exports